var exports = {
  "Tp": "x112a1f60--53d509--background",
  "iE": "x112a1f60--53d509--wrapper",
  "DD": "x112a1f60--53d509--title",
  "VO": "x112a1f60--53d509--full-width",
};

module.exports = exports;
